import styled from 'styled-components';

export const StyledCarouselContainer = styled.div`
  width: 100%;

  .ant-carousel {
    .slick-dots.slick-dots-bottom {
      display: flex !important;
      width: auto;
      bottom: 20px;
      left: 50%;
      right: auto;
      transform: translateX(-50%);
      margin: 0;
      padding: 0;
      list-style: none;
      align-items: center;
      justify-content: center;

      li {
        width: 12px;
        height: 12px;
        margin: 0 4px;
        background: transparent;
        transition: width 0.3s ease;

        &::before,
        &::after {
          display: none !important;
        }

        button {
          display: block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          opacity: 1;
          padding: 0;
          border: none;
          font-size: 0;
          line-height: 0;
          color: transparent;
          cursor: pointer;
          outline: none;
          transition: all 0.3s ease;

          &::before,
          &::after {
            display: none !important;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.7);
          }
        }

        &.slick-active {
          width: 24px;
          background: transparent;

          &::after {
            display: none !important;
          }

          button {
            width: 24px;
            height: 12px;
            border-radius: 6px;
            background: white;
          }
        }
      }
    }

    .slick-slide > div {
      padding: 0;
    }
  }
`;
